export default __webpack_public_path__ + "static/media/PUERTA POLANCO ANEXO_1_PREMIOS_IMPULSO_SUME_BY_SAINT_GOBAIN_2024.200fc8eb.pdf";